var _rect, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClassesIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 254,
    height: 254,
    rx: 15,
    fill: "#EEF0FE",
    stroke: "#4A4A68",
    strokeWidth: 2,
    strokeDasharray: "8 8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 97.499,
    cy: 105.149,
    r: 8.45897,
    fill: "#223BF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.394 103.544C102.786 103.297 104.236 102.55 104.472 100.986",
    stroke: "white",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M193.658 91.4407L136.607 93.6038C136.013 93.6263 135.569 94.1596 135.656 94.7481L137.049 104.256C137.124 104.763 137.57 105.132 138.082 105.11L193.74 102.666C194.275 102.643 194.696 102.202 194.696 101.667V92.44C194.696 91.8729 194.225 91.4192 193.658 91.4407Z",
    fill: "#6476F7",
    stroke: "#6476F7",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M197.746 68.5653L138.904 70.1538C138.336 70.1691 137.896 70.6532 137.933 71.2196L138.351 77.5224C138.387 78.0629 138.847 78.4766 139.388 78.4554L197.812 76.173C198.349 76.152 198.773 75.7109 198.773 75.1738L198.773 69.565C198.773 69.0021 198.309 68.5501 197.746 68.5653Z",
    fill: "#6476F7",
    stroke: "#6476F7",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M126.435 179.809C135.414 188.146 124.363 216.145 116.431 228.534C115.948 229.288 114.869 229.015 114.818 228.12C114.103 215.564 119.819 194.212 105.667 194.927C90.5483 195.691 96.4209 226.386 75.4299 210.656C54.4389 194.927 90.0102 197.539 87.5136 186.408C85.0171 175.278 52.5618 199.619 46.3203 190.465C40.0788 181.311 58.8031 180.063 65.0445 167.164C71.286 154.265 55.3276 154.145 39.5553 163.06C23.8154 171.956 24.88 143.027 54.2577 144.262C54.3741 144.267 54.506 144.298 54.6141 144.342C64.2601 148.236 50.4813 131.957 44.2769 128.234C38.0355 124.49 25.0487 113.206 42.5759 106.414C60.103 99.6216 61.1157 149.391 78.5211 165.948C95.9265 182.504 114.549 168.771 126.435 179.809Z",
    fill: "#1CDBCA",
    stroke: "#1CDBCA",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M197.864 61.0017L139.204 56.6242C138.663 56.5839 138.189 56.9812 138.134 57.5201L137.745 61.3402C137.688 61.9021 138.107 62.3998 138.67 62.4391L197.007 66.5121C197.507 66.5471 197.956 66.2054 198.056 65.7134L198.769 62.1978C198.889 61.6078 198.464 61.0465 197.864 61.0017Z",
    fill: "#6476F7",
    stroke: "#6476F7",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M197.354 40.5965L139.036 49.6975C138.5 49.7811 138.129 50.2757 138.198 50.813L138.691 54.6477C138.761 55.1977 139.266 55.5852 139.816 55.5113L198.777 47.5764C199.359 47.498 199.749 46.9368 199.619 46.3638L198.483 41.363C198.367 40.8504 197.873 40.5154 197.354 40.5965Z",
    fill: "#A2ECE5",
    stroke: "#A2ECE5",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M195.879 36.7155L136.944 33.4638C136.404 33.4339 135.937 33.8403 135.893 34.3803L135.576 38.2334C135.53 38.7861 135.943 39.2703 136.496 39.3125L195.816 43.8388C196.402 43.8835 196.9 43.4158 196.892 42.8283L196.824 37.7006C196.817 37.1749 196.404 36.7445 195.879 36.7155Z",
    fill: "#909DF9",
    stroke: "#909DF9",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M197.599 80.0966L143.29 79.1833C142.738 79.174 142.283 79.6141 142.273 80.1663L142.118 89.4192C142.108 89.984 142.568 90.4446 143.133 90.4359L196.262 89.6176C196.741 89.6102 197.148 89.2643 197.231 88.7926L198.567 81.2713C198.675 80.6654 198.215 80.1069 197.599 80.0966Z",
    fill: "#1CDBCA",
    stroke: "#1CDBCA",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M88.721 112.386C102.353 126.35 152.708 132.376 161.833 126.656C170.903 120.97 166.11 109.988 164.906 106.226C165.751 106.114 167.484 106.216 167.658 107.521C167.876 109.152 167.984 104.585 168.746 104.803C169.355 104.977 170.014 106.687 170.268 107.521L171.682 104.803L172.661 107.521C173.277 106.361 174.596 104.194 174.944 104.803C175.292 105.412 175.669 106.869 175.814 107.521C176.394 106.141 177.685 103.664 178.207 104.803C178.859 106.226 185.711 129.707 171.682 140.147C158.266 150.131 115.327 143.783 110.651 142.639C114.858 144.224 150.03 158.8 176.983 169.757C207.86 182.308 207.334 196.167 207.048 203.681L207.044 203.796C206.813 209.881 203.561 219.229 202.62 222.229C204.623 222.924 215.521 224.301 214.942 228.77C214.363 233.238 188.732 228.7 181.212 227.311C181.621 217.543 190.285 199.822 178.207 189.938C168.457 181.96 156.286 180.211 152.966 182.511C150.579 184.164 151.534 188.149 152.955 194.078L152.966 194.126C156.113 207.255 149.661 218.354 147.844 222.229C147.406 223.163 157.017 226.146 156.286 229.579C156.941 231.347 148.738 230.621 146.61 230.621C146.038 230.621 134.423 230.825 127.189 230.621C126.651 226.111 137.995 211.835 133.546 195.372C130.373 183.632 105.772 173.295 94.4115 165.854C83.0511 158.413 68.3105 151.001 57.0739 125.235C49.005 106.734 54.3858 81.8618 66.7634 72.1952C79.3424 62.3714 95.5391 61.6302 112.088 63.3633C119.608 64.1507 127.21 66.8003 127.701 67.6584C128.191 68.5165 125.862 69.988 126.229 70.6011C126.524 71.0915 127.701 71.1984 127.701 72.195C127.701 73.1917 126.026 72.4447 126.026 73.1917C126.026 73.8815 127.988 74.1894 127.701 75.1377C127.413 76.086 125.371 75.9274 125.371 75.9274C125.371 75.9274 127.701 77.5916 126.965 78.3256C126.229 79.0596 123.655 77.7125 123.655 77.7125C123.655 77.7125 126.026 80.6059 124.479 81.1609C122.933 81.716 115.58 76.4833 100.748 77.1278C76.8218 78.1677 73.1293 96.4148 88.721 112.386Z",
    fill: "#223BF4",
    stroke: "#223BF4",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M141.28 83.9307H183.348C183.91 83.9307 184.366 84.3862 184.366 84.9482C184.366 85.5102 183.91 85.9658 183.348 85.9658H141.28V83.9307Z",
    fill: "#223BF4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M141.459 92.5542L142.483 105.746",
    stroke: "#223BF4",
    strokeWidth: 3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M146.912 92.3488L147.98 105.385",
    stroke: "#223BF4",
    strokeWidth: 3
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M191.235 67.8311L191.606 77.1795",
    stroke: "#223BF4",
    strokeWidth: 3
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M185.391 59.2173L185.009 64.7646",
    stroke: "#223BF4",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M188.353 59.4453L187.971 64.9926",
    stroke: "#223BF4",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4543 95.5358C84.5048 91.8093 92.0068 95.8435 90.9024 101.31C87.9925 99.3158 87.0368 100.787 84.7744 104.271L84.7293 104.34C82.4344 107.874 73.773 106.656 75.3177 105.221C80.3158 100.58 76.4039 99.2624 80.4543 95.5358Z",
    fill: "#1CDBCA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9708 102.576C92.4092 104.437 91.6407 106.119 89.3377 107.329C88.0683 103.58 90.1223 99.2278 92.4287 98.3218C92.8226 99.0234 93.5323 100.715 92.9708 102.576Z",
    fill: "#1CDBCA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassesIllustration);
export default __webpack_public_path__ + "static/media/classes-illustration.a6c8ab2e52e5ef1b9fc6f5525735095c.svg";
export { ForwardRef as ReactComponent };